const i = (e, l) => e.length !== l.length ? !1 : l.every((t) => e.includes(t)), o = ({
  openTo: e,
  defaultOpenTo: l,
  views: t,
  defaultViews: s
}) => {
  const n = t ?? s;
  let r;
  if (e != null)
    r = e;
  else if (n.includes(l))
    r = l;
  else if (n.length > 0)
    r = n[0];
  else
    throw new Error("MUI: The `views` prop must contain at least one view");
  return {
    views: n,
    openTo: r
  };
};
export {
  o as applyDefaultViewProps,
  i as areViewsEqual
};
//# sourceMappingURL=views.mjs.map
